import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../content/ContentContext';
import BrandMark from './BrandMark';

const columns = [
  {
    title: '课程',
    links: [
      { label: '摩斯电码小课堂', to: '/courses' },
      { label: '电阻屏涂鸦板', to: '/courses' },
      { label: '小球平衡挑战', to: '/courses' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '品牌故事', to: '/about' },
      { label: '教研团队', to: '/about' },
      { label: '学校合作', to: '/schools' },
    ],
  },
  {
    title: '联系',
    links: [
      { label: '机构合作咨询', to: '/contact' },
      { label: '新闻中心', to: '/news' },
    ],
  },
];

const Footer = () => {
  const { site } = useContent();
  return (
    <footer className="section-alt">
      <div className="container-x">
        <div className="grid gap-10 py-14 sm:grid-cols-12" style={{ borderTop: '1px solid var(--line)' }}>
          <div className="sm:col-span-5">
            <div className="flex items-center gap-2.5">
              <BrandMark size="md" />
              <span className="text-[17px] font-extrabold tracking-tight" style={{ color: 'var(--ink)' }}>{site.brandName}</span>
            </div>
            <p className="mt-4 max-w-xs text-[14px] leading-relaxed" style={{ color: 'var(--body)' }}>
              {site.company}旗下科创课程包与硬件套件品牌「{site.productBrand}」，面向学校、科技馆、少年宫及培训机构提供内容与交付支持。
            </p>
            <ul className="mt-5 space-y-1.5 text-[13px]" style={{ color: 'var(--muted)' }}>
              <li>电话　{site.phone}</li>
              <li>邮箱　{site.email}</li>
              <li>地址　{site.address}</li>
            </ul>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="sm:col-span-2">
              <h4 className="mb-3 text-[13px] font-bold" style={{ color: 'var(--ink)' }}>{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-[14px] transition-colors hover:text-blue-600" style={{ color: 'var(--muted)' }}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-2 py-6 text-[12px] sm:flex-row"
          style={{ borderTop: '1px solid var(--line)', color: 'var(--muted)' }}>
          <p>© {new Date().getFullYear()} {site.company}　保留所有权利</p>
          <div className="flex flex-wrap items-center justify-center gap-x-4">
            {site.icp && <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer" className="hover:text-blue-600">{site.icp}</a>}
            {site.police && <span>{site.police}</span>}
          </div>
        </div>
        {site.footerNote && <p className="pb-6 text-center text-[12px]" style={{ color: 'var(--muted)' }}>{site.footerNote}</p>}
      </div>
    </footer>
  );
};

export default Footer;